import React from "react";
import { Fonts } from "../../design/Font";

export default class ActiveSwitch extends React.Component{

    render(){
        const {value,onClick} = this.props
        if(value)
            return(
                <div onClick={onClick} style={{display:'flex', flexDirection:'row', width:"4.5vw", height:'2.8vh', border:'2px solid rgba(0,215,140,1)', borderRadius:50, alignItems:'center',justifyContent: 'space-between', cursor:"pointer"}}>
                    <span style={{...Fonts.subtext, color:'rgba(0,215,140,1)', marginLeft:'1vh',}}>Active</span><div style={{justifySelf:'flex-end', width:"3vh",height:"3vh", backgroundColor:"rgba(0,215,140,1)", borderRadius:50,}}/>
                </div>
            ) 
        else
            return(
                <div onClick={onClick} style={{display:'flex', flexDirection:'row', width:"4.5vw", height:'2.8vh', border:'2px solid rgba(215,0,0,1)', borderRadius:50, alignItems:'center',justifyContent: 'space-between', cursor:"pointer"}}>
                    <div style={{justifySelf:'flex-begin', width:"3vh",height:"3vh", backgroundColor:'rgba(215,0,0,1)', borderRadius:50,}}/><span style={{...Fonts.subtext, color:'rgba(215,0,0,1)', marginRight:'1vh',}}>Inactive</span>
                </div>
            )
    }
}